export interface IProductGroup {
  id: string;
  description?: string;
  name: string;
  isLocal: boolean;
  checkType: EInprocessCheckType;
}

export enum EInprocessCheckType {
  TIME, //Every 30min, performer has to process product checking.
  UNIT, // For a lot, performer has to pick randomly 3 product to process product checking
}
